import React from 'react';
import {Switch, Route, Redirect, useLocation} from 'react-router-dom';
import { SingleCard } from './layouts';
import { LoginForm, ResetPasswordForm, ChangePasswordForm, CreateAccountForm, ConfirmAccountForm } from './components';
import { getLoginRedirectLocation } from './utils/navigation.utils';

const UnauthenticatedContent = () => {
    const location = useLocation();
    const pathname = location.pathname;
  return (
    <Switch>
      <Route exact path='/login/:admin?' >
        <SingleCard title="Личный кабинет юридических лиц">
          <LoginForm />
        </SingleCard>
      </Route>
      <Route exact path='/create-account' >
        <SingleCard className={'two-columns'} title="Регистрация пользователя">
          <CreateAccountForm />
        </SingleCard>
      </Route>
      <Route exact path='/reset-password' >
        <SingleCard
          title="Восстановление пароля"
          description="Введите email, с которым Вы регистрировались, и мы отправим Вам ссылку для смены пароля">
          <ResetPasswordForm />
        </SingleCard>
      </Route>
      <Route exact path='/change-password/:recoveryCode/:isset?' >
        <SingleCard title={pathname.slice(-4) === "true" ? "Установка пароля" : "Смена пароля"}>
          <ChangePasswordForm />
        </SingleCard>
      </Route>
        <Route exact path='/change-email/:recoveryCode/:isset?' >
            <SingleCard title={pathname.slice(-4) === "true" ? "Установка пароля" : "Смена пароля"}>
                <ChangePasswordForm />
            </SingleCard>
        </Route>
      <Route exact path='/confirm-account/:userId/:confirmCode' >
        <SingleCard title="Подтверждение аккаунта">
          <ConfirmAccountForm />
        </SingleCard>
      </Route>
      <Redirect to={getLoginRedirectLocation(location.pathname, location.search)} />
    </Switch>
  );
}

export default UnauthenticatedContent
